import ModalBase from './ModalBase';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../providers/ConfigProvider';

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        flexDirection: "column",
        '& .title': { fontWeight: 700 },
        '& .actions': { display: "flex", flexDirection: "column" },
        '& .MuiButtonBase-root': { width: "220px", marginTop: "10px" },
    },
}));

function ChoosePaymentMethodModal({ cashState, cashModuleEnabled, onChoosePin, onChooseCash, onCancel }) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { StyleConfig } = useConfig();
    const cashDisabled = cashState !== 'Ready' || cashModuleEnabled === false; // omitted prop defaults to not disabling on this account

    return (
        <ModalBase>
            <div id="choosePaymentMethodModal" className={classes.root}>
                <h2 className="title">{t('cash.choose-payment-method')}</h2>
                <h3 className="gray subtitle">{t('cash.choose-payment-method-sub')}</h3>
                <div className="actions mt1">
                    <Button
                        onClick={onChoosePin}
                        variant="contained"
                        className="darkgreen-btn"
                        style={StyleConfig?.DefaultButtonColorStyle ?? {}}
                    >{t('cash.pin')}</Button>
                    <Button
                        onClick={onChooseCash}
                        disabled={cashDisabled}
                        variant="contained"
                        className="darkgreen-btn"
                        style={StyleConfig?.DefaultButtonColorStyle ?? {}}
                    >{t('cash.cash')}</Button>
                    <Button
                        onClick={onCancel}
                        variant="contained"
                        className="red-btn"
                    >{t('cash.cancel')}</Button>
                </div>
            </div>
        </ModalBase>
    );
}

export default ChoosePaymentMethodModal;
